import { createAction } from 'redux/helpers/actions';
import types from './types';

export default {
  getAll: data => createAction(types.getAll, data),
  getAllSuccess: data => createAction(types.getAllSuccess, data),
  getAllFailure: data => createAction(types.getAllFailure, data),

  update: data => createAction(types.update, data),
  updateSuccess: data => createAction(types.updateSuccess, data),
  updateFailure: data => createAction(types.updateFailure, data),

  sync: data => createAction(types.sync, data),
  syncSuccess: data => createAction(types.syncSuccess, data),
  syncFailure: data => createAction(types.syncFailure, data),
};
